import JsFunction from '@/models/JsFunction';

export default class JsFunctionRepository {
    public static getAll() {
        return JsFunction.query().get();
    }
}
